export default "/_next/static/chunks/fonts/Advance-Line-Icon-23ebd7eba15b80ccb6c1895543da9fb9.ttf";